import { render, staticRenderFns } from "./PageWorkSheet.vue?vue&type=template&id=635d67e0&scoped=true&"
import script from "./PageWorkSheet.vue?vue&type=script&lang=js&"
export * from "./PageWorkSheet.vue?vue&type=script&lang=js&"
import style0 from "./PageWorkSheet.vue?vue&type=style&index=0&id=635d67e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d67e0",
  null
  
)

export default component.exports